import { CREATE_SUPPORT_TICKET_REQUEST } from '../constants/action-types';

export const requestCreateSupportTicket = data => ({
  type: CREATE_SUPPORT_TICKET_REQUEST,
  data,
});
